'use client'

import React from 'react'
import classNames from 'classnames'
import { CDN_PREVIEW_URL } from '@/utils/constants'
import type { BidCollection } from '@/utils/bids'
import CollectionArt, { useBrokenImageWatch } from './collection-art'

/**
 * Inscription preview with a fallback: the CDN has no preview for some
 * content (text, recursive, unindexed), so a failed load — even one that
 * happened before hydration — shows the collection's art instead of a
 * broken-image glyph.
 */
export default function InscriptionThumb({
	id,
	collection,
	hoverScale = false
}: {
	id: string
	collection: BidCollection
	hoverScale?: boolean
}) {
	const [ref, broken] = useBrokenImageWatch()
	if (broken) return <CollectionArt collection={collection} />
	return (
		<span ref={ref} className="absolute inset-0 block">
			<img
				src={`${CDN_PREVIEW_URL}/${id}`}
				alt=""
				loading="lazy"
				decoding="async"
				className={classNames(
					'absolute inset-0 size-full object-cover [image-rendering:pixelated]',
					hoverScale && 'transition-transform duration-500 group-hover:scale-105'
				)}
			/>
		</span>
	)
}
